import React, { useState } from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import FilterClaims from '../Claims/FilterClaims';
import FilterHcpClaims from '../Claims/FilterHcpClaims';
import { ClaimStatusEnum } from '../../enum';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ClaimsWrapper = (props) => {
  const classes = useStyle();
  const [value, setValue] = useState(0);
  const FilterComponent = props.type === 'Hospital' ? FilterHcpClaims : FilterClaims;

  const getClaimStatus = (tabValue) => {
    switch (tabValue) {
      case 0: return ClaimStatusEnum.docs_pending;
      case 1: return ClaimStatusEnum.verification;
      case 2: return ClaimStatusEnum.Approved;
      case 3: return ClaimStatusEnum.Rejected;
      default: return ClaimStatusEnum.docs_pending;
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    const status = getClaimStatus(newValue);
    props.getClaimsByStatus(status, function() {
      props.getClaimsFiltered();
    });
  };

  const sharedFilterProps = {
    pagingData: props.pagingData,
    claimsData: props.claimsData,
    loading: props.loading,
    type: props.type,
    getClaimsFiltered: props.getClaimsFiltered,
    getClaimsByStartDate: props.getClaimsByStartDate,
    getClaimsByEndDate: props.getClaimsByEndDate,
    hasBulkApprove: props.hasBulkApprove,
    handleBulkApproval: props.handleBulkApproval,
    hasAlerts: props.hasAlerts,
    showBulkApproveProgressAlert: props.showBulkApproveProgressAlert,
    showBulkApproveSuccessAlert: props.showBulkApproveSuccessAlert,
    showBulkApproveErrorAlert: props.showBulkApproveErrorAlert,
    bulkApproveError: props.bulkApproveError,
    resetBulkApproveSuccessAlert: props.resetBulkApproveSuccessAlert,
    resetBulkApproveErrorAlert: props.resetBulkApproveErrorAlert,
  };

  return (
    <>
      <section className={classes.claimswrapper}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="claims dashboards"
                variant="scrollable"
                scrollButtons="auto"
                className={classes.tabs}
              >
                <Tab label="Docs Pending" {...a11yProps(0)} disabled={props.loading} />
                <Tab label="Verification" {...a11yProps(1)} disabled={props.loading} />
                <Tab label="Approved" {...a11yProps(2)} disabled={props.loading} />
                <Tab label="Rejected" {...a11yProps(3)} disabled={props.loading} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <FilterComponent {...sharedFilterProps} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <FilterComponent {...sharedFilterProps} />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <FilterComponent {...sharedFilterProps} />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <FilterComponent {...sharedFilterProps} />
            </TabPanel>
          </Grid>
        </Grid>
      </section>
    </>
  );
};

export default ClaimsWrapper;
